import React, { useState } from "react";
import { Box } from '@mui/material';
import { XranColumns } from './XranColumns';
import { xranData } from 'static/StaticData';
import XranDataGrid from "views/common/XranDataGrid";

const XranScreen = ({ user, features }) => {
    const [rows, setRows] = React.useState(xranData);
    const [, setMatchedRecords] = useState([]);
    const [filterMode] = useState("all");

    const handleDelete = (id) => {
        setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    };

    const handleSwitchChange = (id, field, checked) => {
        setRows((prevRows) =>
            prevRows.map((row) =>
                row.id === id ? { ...row, [field]: checked } : row
            )
        );
    };

    const handleDateChange = (id, field, value) => {
        setRows((prevRows) =>
            prevRows.map((row) =>
                row.id === id ? { ...row, [field]: value } : row
            )
        );
    };

    const handleInputChange = (id, field, value) => {
        setRows((prevRows) =>
            prevRows.map((row) =>
                row.id === id ? { ...row, [field]: value } : row
            )
        );
    };

    const rowsToDisplay = rows;

    const columns = XranColumns({
        handleDelete,
        handleSwitchChange,
        handleDateChange,
        handleInputChange
    });

    return (
        // <div style={{
        //     backgroundColor: '#FFF',
        //     height: '100%',
        //     width: '100%',
        //     padding: "2rem",
        //     display: 'grid',
        //     gridTemplateRows: 'auto 1fr',
        //     gap: '1rem',
        //     alignItems: 'start',
        //     overflowX: 'hidden'
        // }}>
        <Box sx={{
            height: '100%',
            width: '100%',
            padding: "2rem",
            display: 'grid',
            gridTemplateRows: 'auto 1fr',
            gap: '1rem',
            alignItems: 'start',
            overflowX: 'hidden',
        }}>
            <XranDataGrid
                datagridName={"findReplaceResults"}
                filteredRows={
                    filterMode === "all"
                        ? rowsToDisplay
                        : filterMode === "success"
                            ? rowsToDisplay.filter((row) => row.Msgtype === "S")
                            : rowsToDisplay.filter((row) => row.Msgtype === "E")
                }
                rows={rowsToDisplay}
                columns={columns}
                pageSize={10}
                pagination={true}
                setRows={setMatchedRecords}
                showExport={false}
                sx={{
                    height: '100%',
                    width: '100%',
                    display: 'grid',
                    gridTemplateRows: '1fr',
                    minHeight: 0,
                    overflow: 'hidden'
                }}
            />
        </Box>
    );
};

export default XranScreen;
